export default {
  adminGestion: {
    title: 'CRM-Verwaltung',
    selectCountry: 'Land auswählen',
    noCountries: 'Kein Land verfügbar. Bitte kontaktieren Sie einen Administrator.',
    nav: {
      dashboard: 'Dashboard',
      groups: 'Gruppen',
      facilities: 'Einrichtungen',
      redaction: 'Redaktion',
      dossiers: 'Dossiers',
      blog: 'Blog'
    },
    stats: {
      facilities: 'Einrichtungen',
      groups: 'Gruppen',
      leads: 'Interessenten'
    },
    groups: {
      title: 'Gruppenverwaltung',
      search: 'Gruppe suchen...',
      columns: {
        logo: 'Logo',
        name: 'Name',
        facilities: 'Einrichtungen',
        users: 'Benutzer'
      },
      contact: {
        title: 'Hauptkontakt',
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'Email',
        phone: 'Telefon',
        address: 'Adresse',
        postalCode: 'Postleitzahl',
        city: 'Stadt',
        edit: 'Kontakt bearbeiten',
        save: 'Speichern',
        cancel: 'Abbrechen'
      },
      users: {
        title: 'Benutzerverwaltung',
        add: 'Benutzer hinzufügen',
        email: 'Email',
        password: 'Passwort',
        passwordOptional: 'optional - leer lassen, um nicht zu ändern',
        passwordPlaceholder: 'Leer lassen, um das aktuelle Passwort zu behalten',
        generate: 'Generieren',
        fullName: 'Vor- und Nachname',
        role: 'Rolle',
        roles: {
          groupUser: 'Gruppenbenutzer',
          facilityUser: 'Einrichtungsbenutzer'
        },
        defaultLanguage: 'Standardsprache',
        languageHint: 'Wählen Sie eine der verfügbaren Sprachen in den Ländern der Gruppe',
        cancel: 'Abbrechen',
        create: 'Benutzer erstellen',
        update: 'Aktualisieren',
        saving: 'Speichern...',
        edit: 'Bearbeiten',
        remove: 'Löschen'
      },
      actions: {
        manageUsers: 'Benutzer verwalten',
        editContact: 'Kontakt bearbeiten'
      }
    },
    facilities: {
      title: 'Einrichtungen',
      search: 'Einrichtung suchen...',
      allGroups: 'Alle Gruppen',
      allTypes: 'Alle Typen',
      columns: {
        name: 'Name',
        types: 'Typen',
        location: 'Standort',
        group: 'Gruppe',
        paying: 'Bezahlt'
      },
      actions: {
        edit: 'Bearbeiten'
      },
      pagination: {
        show: 'Anzeigen',
        showing: '{from}-{to} von {total} Einrichtungen',
        previous: 'Vorherige',
        next: 'Nächste',
        to: 'zu',
        of: 'von',
        results: 'Ergebnisse'
      },
      add: {
        title: 'Einrichtung hinzufügen',
        name: 'Name',
        description: 'Beschreibung',
        address: 'Adresse',
        city: 'Stadt',
        postalCode: 'Postleitzahl',
        latitude: 'Breitengrad',
        longitude: 'Längengrad',
        nationalId: 'Nationales Identifikationsmerkmal (FINESS)',
        types: 'Typen',
        typesHint: 'Halten Sie Ctrl/Cmd gedrückt, um mehrere Typen auszuwählen',
        geoEntity: 'Geografische Zone',
        selectGeoEntity: 'Geografische Zone auswählen',
        group: 'Gruppe',
        noGroup: 'Keine Gruppe',
        phone: 'Telefon',
        email: 'Email',
        website: 'Website',
        cancel: 'Abbrechen',
        create: 'Einrichtung erstellen',
        creating: 'Erstellen...',
        button: 'Einrichtung hinzufügen',
        trigrame:'Trigrame',
        type:'Typ',
        typePrive:'Privat',
        typePriveNL:'Privat nicht-kommerziell',
        typePublic:'Öffentlich',
        
      },
      edit: {
        title: 'Einrichtung bearbeiten',
        save: 'Änderungen speichern',
        saving: 'Speichern...'
      },
      details: {
        title: 'Einrichtungsdetails',
        info: {
          title: 'Informationen',
          subtitle: 'Allgemeine Informationen zur Einrichtung',
          name: 'Name',
          types: 'Typen',
          group: 'Gruppe',
          noGroup: 'Keine Gruppe',
          contact: 'Kontakt',
          description: 'Beschreibung',
          trafficStats: 'Traffic-Statistiken',
          trafficStatsDescription: 'Übersicht der Besuche auf der Website der Einrichtung',
          dateStart: 'Startdatum',
          dateEnd: 'Enddatum',
          granularity: 'Granularität',
          day: 'Tag',
          week: 'Woche',
          month: 'Monat',
          noTrafficData: 'Keine Daten für die ausgewählte Periode verfügbar'
        },
        users: {
          title: 'Utilisateurs',
          subtitle: 'Gestionnaires de l\'établissement',
          fullName: 'Nom complet',
          email: 'Email',
          createdAt: 'Erstellungsdatum',
          password: 'Passwort',
          passwordOptional: 'Optional - leer lassen, um nicht zu ändern',
          passwordPlaceholder: 'Leer lassen, um das aktuelle Passwort zu behalten',
          defaultLanguage: 'Standardsprache',
          generate: 'Generieren',
          addUser: 'Benutzer hinzufügen',
          editUser: 'Benutzer bearbeiten',
          emailNoEdit: 'Die Email kann nicht geändert werden',
          noUsers: 'Keine Benutzer für diese Einrichtung',
          addFirstUser: 'Ersten Benutzer hinzufügen',
          confirmDelete: 'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?',
          validation: {
            requiredFields: 'Name und Email sind erforderlich',
            passwordRequired: 'Passwort ist erforderlich für einen neuen Benutzer'
          }
        },
        contacts: {
          title: 'Kontakte',
          subtitle: 'Liste der Kontakte der Einrichtung',
          noContacts: 'Keine Kontakte',
          add: 'Kontakt hinzufügen',
          edit: 'Bearbeiten',
          delete: 'Löschen',
          form: {
            title: 'Kontakt',
            role: 'Rolle',
            selectRole:'Rolle auswählen',
            name: 'Name',
            phone: 'Telefon',
            mobile: 'Mobiltelefon',
            email: 'Email',
            save: 'Speichern',
            cancel: 'Abbrechen',
            saving: 'Speichern...',
            roleList:{
              role1:'Direktor',
              role2:'Sekretär',
              role3:'Assistentin',
              role4:'Berater',
              role5:'Regionaldirektor',
              role6:'Andere'
            }
          }
        },
        features: {
            title: 'Eigenschaften',
          subtitle: 'Eigenschaften der Einrichtung',
          noFeatures: 'Keine Eigenschaften konfiguriert'
        },
        timeline: {
          title: 'Verlauf',
          subtitle: 'Verlauf der Änderungen',
          noEvents: 'Keine Ereignisse',
          unknownUser: 'Unbekannter Benutzer'
        },
        housing: {
          title: 'Unterkünfte',
          subtitle: 'Verfügbare Unterkünfte',
          noUnits: 'Keine Unterkünfte konfiguriert',
          add: 'Unterkünfte hinzufügen',
          edit: 'Bearbeiten',
          delete: 'Löschen',
          type: 'Typ',
          units: 'Anzahl',
          area: 'Fläche (m²)',
          price: 'Preis/Monat',
          form: {
            title: 'Unterkünfte',
            type: 'Typ',
            units: 'Anzahl',
            area: 'Fläche (m²)',
            price: 'Preis pro Monat',
            pricePerDay: 'Preis pro Tag',
            priceConversionNote: 'Tagespreis × 30 = Monatspreis',
            currency: 'Währung',
            notes: 'Notizen',
            save: 'Speichern',
            cancel: 'Abbrechen',
            saving: 'Speichern...',
            multiAdd: 'Mehrere Typen hinzufügen',
            selectTypes: 'Typen auswählen',
            typesSelected: 'Typ(en) ausgewählt',
            addAnother: 'Weitere hinzufügen +'
          }
        },
        media: {
          title: 'Fotos und Videos',
          subtitle: 'Medien der Einrichtung',
          noMedia: 'Keine Medien',
          add: 'Fotos und Videos hinzufügen',
          dragDrop:'Ziehen Sie Fotos und Videos hierher',
          edit: 'Bearbeiten',
          delete: 'Löschen',
          upload: 'Hochladen',
          form: {
            title: 'Medien',
            type: 'Typ',
            file: 'Datei',
            alt: 'Alternativer Text',
            save: 'Speichern',
            cancel: 'Abbrechen',
            saving: 'Speichern...'
          },
          types: {
            photo: 'Photo',
            exterior: 'Außen',
            interior: 'Innen',
            room: 'Zimmer',
            dining: 'Essen',
            common: 'Gemeinschaftsraum',
            video: 'Video'
          }
        },
        documents: {
            title: 'Dokumente',
          subtitle: 'Dokumente der Einrichtung',
          noDocuments: 'Keine Dokumente',
          add: 'Dokument hinzufügen',
          upload: 'Hochladen',
          view: 'Ansehen',
          delete: 'Löschen',
          form: {
            title: 'Dokument',
            type: 'Typ',
            file: 'Datei',
            name: 'Name',
            save: 'Speichern',
            cancel: 'Abbrechen',
            saving: 'Speichern...'
          }
        }
      },
      name: 'Name',
      type: 'Typ',
      location: 'Standort',
      view: 'Ansehen',
      list: 'Liste der Einrichtungen',
      loading: 'Laden der Einrichtungen...',
      noFacilities: 'Keine Einrichtungen gefunden',
      show: 'Anzeigen',
      to: 'zu',
      of: 'von',
      results: 'Ergebnisse',
      previous: 'Vorherige',
      next: 'Nächste',
      viewPublicPage: 'Seite öffnen',
      establishmentsUnit: 'Einrichtungen',
      searchPlaceholder: 'Nach Name, Stadt oder Land suchen...'
    },
    redaction: {
      dossiers: {
        title: 'Dossierverwaltung',
        categories: {
          title: 'Kategorien',
          add: 'Kategorie hinzufügen',
          edit: 'Kategorie bearbeiten',
          name: 'Name',
          slug: 'Slug',
          description: 'Beschreibung',
          parent: 'Übergeordnete Kategorie',
          noParent: 'Keine übergeordnete Kategorie',
          position: 'Position',
          active: 'Aktiv',
          image: 'Bild',
          noCategories: 'Keine Kategorien',
          confirmDelete: 'Sind Sie sicher, dass Sie diese Kategorie löschen möchten?'
        },
        articles: {
          title: 'Artikel',
          add: 'Neuer Artikel',
          edit: 'Artikel bearbeiten',
          list: 'Liste der Artikel',
          allArticles: 'Alle Artikel',
          title_field: 'Titel',
          slug: 'Slug',
          excerpt: 'Auszug',
          content: 'Inhalt',
          category: 'Kategorie',
          selectCategory: 'Kategorie auswählen',
          seoTitle: 'Titel SEO',
          seoDescription: 'Beschreibung SEO',
          image: 'Bild',
          published: 'Veröffentlicht',
          publishedAt: 'Veröffentlichungsdatum',
          author: 'Autor',
          viewCount: 'Ansichten',
          noArticles: 'Keine Artikel',
          confirmDelete: 'Sind Sie sicher, dass Sie diesen Artikel löschen möchten?',
          draft: 'Entwurf',
          publish: 'Veröffentlichen'
        }
      },
      blog: {
        title: 'Blogverwaltung',
        categories: {
          title: 'Kategorien',
          add: 'Kategorie hinzufügen',
          edit: 'Kategorie bearbeiten',
          name: 'Name',
          slug: 'Slug',
          description: 'Beschreibung',
          parent: 'Übergeordnete Kategorie',
          noParent: 'Keine übergeordnete Kategorie',
          position: 'Position',
          active: 'Aktiv',
          image: 'Bild',
          noCategories: 'Keine Kategorien',
          confirmDelete: 'Sind Sie sicher, dass Sie diese Kategorie löschen möchten?'
        },
        articles: {
          title: 'Artikel',
          add: 'Neuer Artikel',
          edit: 'Artikel bearbeiten',
          list: 'Liste der Artikel',
            allArticles: 'Alle Artikel',
          title_field: 'Titel',
          slug: 'Slug',
          excerpt: 'Auszug',
          content: 'Inhalt',
          category: 'Kategorie',
          selectCategory: 'Kategorie auswählen',
          seoTitle: 'Titel SEO',
          seoDescription: 'Beschreibung SEO',
          image: 'Bild',
          published: 'Veröffentlicht',
          publishedAt: 'Veröffentlichungsdatum',
          author: 'Autor',
          viewCount: 'Ansichten',
          noArticles: 'Keine Artikel',
          confirmDelete: 'Sind Sie sicher, dass Sie diesen Artikel löschen möchten?',
          draft: 'Entwurf',
          publish: 'Veröffentlichen'
        }
      }
    }
  },
  adminConfig: {
    leadForms: {
      title: 'Lead-Formulare verwalten',
      description: 'Verwalten Sie Lead-Formulare nach Land und erstellen Sie Schritte und benutzerdefinierte Felder.',
      selectCountry: 'Land auswählen',
      selectCountryPrompt: 'Land auswählen',
      formList: 'Liste der Lead-Formulare',
      createNew: 'Neues Lead-Formular erstellen',
      createFormTitle: 'Neues Lead-Formular erstellen',
      noForms: 'Kein Lead-Formular für dieses Land. Erstellen Sie ein neues.',
      form: {
        name: 'Name',
        slug: 'Slug',
        slugHelp: 'Eindeutige Kennung für dieses Formular (wird in URLs verwendet)',
        description: 'Beschreibung'
      },
      steps: {
        title: 'Schritte',
        list: 'Liste der Schritte',
        add: 'Schritt hinzufügen',
        create: 'Schritt erstellen',
        name: 'Name des Schritts',
        enableLoader: 'Benutzerdefinierter Loader aktivieren',
        loaderHtml: 'HTML des Loaders',
        loaderHtmlHelp: 'HTML-Code, der während des Ladens dieses Schritts angezeigt wird',
        hasLoader: 'Dieser Schritt verfügt über einen benutzerdefinierten Loader',
        confirmDelete: 'Sind Sie sicher, dass Sie diesen Schritt löschen möchten? Die zugehörigen Felder bleiben bestehen, aber werden nicht mehr mit diesem Schritt verknüpft.',
        noSteps: 'Keine Schritte für dieses Formular. Erstellen Sie einen neuen.'
      },
      fields: {
        title: 'Felder',
        global: 'Globale Felder',
        addGlobal: 'Globales Feld hinzufügen',
        stepFields: 'Felder für Schritt : {name}',
        addToStep: 'Feld hinzufügen',
        noGlobalFields: 'Keine globalen Felder. Erstellen Sie ein neues.',
        noStepFields: 'Keine Felder für diesen Schritt. Erstellen Sie ein neues.',
        add: 'Feld hinzufügen',
        edit: 'Feld bearbeiten',
        hasOptions: 'Mit Optionen',
        confirmDelete: 'Sind Sie sicher, dass Sie dieses Feld löschen möchten?',
        types: {
          text: 'Text',
          email: 'E-Mail',
          tel: 'Telefon',
          number: 'Zahl',
          boolean: 'Ja/Nein',
          checkbox: 'Checkbox',
          selectBouton: 'Auswahlformular',
          select: 'Auswahl',
          date: 'Datum',
          department: 'Departement',
          department_city: 'Departement + Stadt'
        },
        form: {
          label: 'Bezeichnung',
          type: 'Type',
          step: 'Schritt',
          noStep: 'Globales Feld (außerhalb des Schritts)',
          options: 'Options',
          optionPlaceholder: 'Wert der Option',
          addOption: 'Option hinzufügen'
        }
      }
    }
  },
  common: {
    yes: 'Ja',
    no: 'Nein',
    edit: 'Bearbeiten',
    back: 'Zurück',
    add: 'Hinzufügen',
    select:'Auswählen',
    save: 'Speichern',
    saving: 'Speichern...',
    cancel: 'Abbrechen',
    loading: 'Laden...',
    signOut: 'Abmelden',
    close: 'Schließen',
    delete: 'Löschen',
    remove: 'Entfernen',
    or: 'oder',
    upTo: 'bis',
    selectLeadPrompt: 'Wählen Sie eine Anfrage aus, um die Details anzuzeigen.',
    modify: 'Bearbeiten',
    create: 'Erstellen',
    ok: 'OK'
  },
  validation: {
    required: 'Dieses Feld ist erforderlich',
    uniqueSlug: 'Dieser Slug wird bereits für dieses Land verwendet'
  },
  errors: {
      fileTooLarge: 'Die Datei ist zu groß (maximal {size})',
    fileTypeNotAllowed: 'Dieser Dateityp ist nicht erlaubt',
    fileRequired: 'Bitte wählen Sie eine Datei',
    uploadFailed: 'Das Hochladen ist fehlgeschlagen'
  },
  facility: {
    title: 'Einrichtung',
    user: 'Benutzer',
    manager: 'Einrichtungsmanager',
    facilityManager: 'Einrichtungsmanager',
    nav: {
      dashboard: 'Dashboard',
      info: 'Informationen',
      contacts: 'Kontakte',
      housing: 'Unterkünfte',
      features: 'Merkmale',
      media: 'Medien',
      documents: 'Dokumente',
      leads: 'Interessenten'
    },
    info: {
      title: 'Einrichtungsinformationen',
      name: 'Name',
      address: 'Adresse',
      city: 'Stadt',
      postalCode: 'Postleitzahl',
      phone: 'Telefon',
      email: 'E-Mail',
      website: 'Website',
      description: 'Description',
      type: 'Einrichtungstyp',
      group: 'Gruppe',
      edit: 'Bearbeiten',
      save: 'Speichern',
      cancel: 'Abbrechen',
      updated: 'Informationen aktualisiert',
      trafficStats: 'Traffic-Statistiken',
      trafficStatsDescription: 'Übersicht der Besuche auf Ihrer Einrichtungsseite',
      dateStart: 'Startdatum',
      dateEnd: 'Enddatum',
      granularity: 'Granularität',
      day: 'Tag',
      week: 'Woche',
      month: 'Monat',
      noTrafficData: 'Keine Daten für die ausgewählte Periode verfügbar'
    },
    dashboard: {
      totalLeads: 'Gesamte Interessenten',
      newLeads: 'Neue Interessenten',
      reviews: 'Bewertungen',
      trafficStats: 'Traffic-Statistiken',
      trafficStatsDescription: 'Übersicht der Besuche auf Ihrer Einrichtungsseite',
      dateStart: 'Startdatum',
      dateEnd: 'Enddatum',
      granularity: 'Granularität',
      day: 'Tag',
      week: 'Woche',
      month: 'Monat',
      noTrafficData: 'Keine Daten für die ausgewählte Periode verfügbar',
      visits: 'Besuche'
    },
    contacts: {
      addContact: 'Kontakt hinzufügen',
      editContact: 'Kontakt bearbeiten',
      newContact: 'Neuer Kontakt',
      role: 'Funktion',
      selectRole: 'Funktion auswählen',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      mobile: 'Mobiltelefon',
      actions: 'Actions',
      noContacts: 'Kein Kontakt für diese Einrichtung',
      confirmDelete: 'Möchten Sie diesen Kontakt wirklich löschen?',
      deleteContact: 'Kontakt löschen',
      roles: {
        director: 'Direktor',
        secretary: 'Sekretär',
        assistant: 'Assistent',
        commercial: 'Verkäufer',
        regional: 'Regionaldirektor',
        other: 'Andere'
      }
    },
    housing: {
      addUnit: 'Unterkünfte hinzufügen',
      editUnit: 'Unterkünfte bearbeiten',
      newUnit: 'Neues Unterkünfte',
      type: 'Type',
      selectType: 'Typ auswählen',
      units: 'Anzahl der Einheiten',
      area: 'Fläche',
      price: 'Preis pro Monat',
      currency: 'Währung',
      notes: 'Notizen',
      noUnits: 'Keine Unterkünfte konfiguriert',
      confirmDelete: 'Möchten Sie dieses Unterkünfte wirklich löschen?',
      deleteUnit: 'Unterkünfte löschen',
      actions: 'Aktionen',
      typeRequired: 'Der Typ des Unterkünftes ist erforderlich',
      unitsPositive: 'Die Anzahl der Einheiten muss größer als Null sein'
    },
    features: {
      noCategories: 'Keine Kategorien für Merkmale verfügbar für Ihr Land',
      noCategoryFeatures: 'Keine Merkmale in dieser Kategorie',
      addNotes: 'Notizen hinzufügen (optional)',
      allCategories: 'Alle Kategorien'
    },
    media: {
      title: 'Medien',
      noMedia: 'Keine Medien hinzugefügt',
      addMedia: 'Medien hinzufügen',
      mediaType: 'Medientyp',
      altText: 'Text für Bildbeschreibung',
      altTextPlaceholder: 'Beschreibung des Mediens',
      file: 'Datei',
      uploadFile: 'Datei hochladen',
      dragDrop: 'Ziehen und Ablegen',
      noAltText: 'Keine Beschreibung',
      confirmDelete: 'Möchten Sie dieses Medien wirklich löschen?',
      mainMedia: 'Hauptmedi',
      setAsMain: 'Als Hauptmedi setzen',
      delete: 'Löschen'
    },
    documents: {
      title: 'Broschüren',
      noDocuments: 'Keine Broschüre hinzugefügt',
      addDocument: 'Broschüre hinzufügen',
      name: 'Name',
      namePlaceholder: 'Name der Broschüre',
      file: 'Datei',
      uploadFile: 'Datei hochladen',
      dragDrop: 'Ziehen und Ablegen',
      viewDocument: 'Dokument ansehen',
      confirmDelete: 'Möchten Sie diese Broschüre wirklich löschen?',
      delete: 'Löschen'
    },
    leads: {
      title: 'Interessenten',
      loading: 'Lade Interessenten...',
      noLeads: 'Keine Interessenten',
      markAsRead: 'Als gelesen markieren',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      date: 'Datum',
      actions: 'Aktionen',
      view: 'Ansehen',
      details: {
        title: 'Interessentendetails',
        urgencyDelay: "Dauersuche",
        searchReason: "Suche nach",
        monthlyBudget: "Monatlicher Budget",
        searchArea: "Geographische Zone",
        loadingGeo: "Lade geographische Informationen...",
        loadingGeoShort: "Lade...",
        geoNotFound: "Nicht gefunden",
        senior1: "Person 1",
        senior2: "Person 2",
        senior: "Person",
        lastName: "Nachname",
        firstName: "Vorname",
        civility: "Anrede",
        age: "Alter",
        residencePostalCode: "Postleitzahl der Wohnung",
        currentStayLocation: "Aktueller Aufenthaltsort",
        currentPlace: "Aktueller Aufenthaltsort",
        autonomyLevel: "Autonomiegrad",
        cognitiveIssues: "Kognitive Probleme"
      },
      back: 'Zurück',
      message: 'Nachricht',
      budget: 'Monatlicher Budget',
      couple: 'Paar',
      delay: 'Dauersuche',
      person1: 'Person 1',
      person2: 'Person 2',
      fullName: 'Vollständiger Name',
      age: 'Alter',
      geoSearch: {
        city: 'Stadt : {name} {code} in einem Radius von {radius} km',
        department: 'Departement : {name} {code}'
      },
      forFacility: 'für'
    }
  },
  group: {
    title: 'Dashboard des Gruppen',
    groupUser: 'Gruppenmitglied',
    groupManager: 'Gruppenmanager',
    nav: {
      dashboard: 'Dashboard',
      facilities: 'Einrichtungen',
      reporting: 'Berichte',
      leads: 'Interessenten'
    },
    facilities: {
      name: 'Name',
      type: 'Typ',
      location: 'Standort',
      actions: 'Aktionen',
      view: 'Ansehen',
      forFacility: 'für',
      list: 'Liste der Einrichtungen',
      loading: 'Lade Einrichtungen...',
      noFacilities: 'Keine Einrichtungen gefunden',
      show: 'Anzeigen',
      to: 'zu',
      of: 'von',
      results: 'Ergebnisse',
      previous: 'Vorherige',
      next: 'Nächste',
      viewPublicPage: 'Öffentliche Seite ansehen'
    },
    dashboard: {
      facilities: 'Einrichtungen',
      totalLeads: 'Gesamte Interessenten',
      newLeads: 'Neue Interessenten',
      trafficStats: 'Traffic-Statistiken',
      trafficStatsDescription: 'Übersicht der Besuche auf Ihrer Einrichtungsseite',
      dateStart: 'Startdatum',
      dateEnd: 'Enddatum',
      granularity: 'Granularität',
      day: 'Tag',
      week: 'Woche',
      month: 'Monat',
      allFacilities: 'Alle Einrichtungen',
      searchFacilityPlaceholder: 'Einrichtung suchen...',
      noTrafficData: 'Keine Daten für die ausgewählte Periode verfügbar',
      visits: 'Besuche',
      latestLeads: 'Letzte Interessenten',
      latestLeadsDescription: 'Letzte 100 Interessenten'
    },
    reporting: {
      period: 'Reporting-Periode',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      totalContacts: 'Gesamte Interessenten',
      mostContactedFacility: 'Am meisten besuchte Einrichtung',
      averageContactsPerDay: 'Durchschnittliche Anfragen pro Tag',
      totalVisits: 'Gesamte Besuche',
      mostVisitedFacility: 'Am meisten besuchte Einrichtung',
      averageVisitsPerDay: 'Durchschnittliche Besuche pro Tag',
      facilitiesList: 'Liste der Einrichtungen',
      searchFacility: 'Einrichtung suchen...',
      contacts: 'Interessenten',
      visits: 'Besuche',
      showing: 'Anzeigen',
      to: 'zu',
      of: 'von',
      results: 'Ergebnisse'
    },
    leads: {
      title: 'Interessenten',
      loading: 'Lade Interessenten...',
      noLeads: 'Keine Interessenten',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      date: 'Datum',
      facility: 'Einrichtung',
      actions: 'Aktionen',
      view: 'Ansehen',
      forFacility: 'für',
      latestLeadsReceived: '{count} letzte Interessenten',
      unreadLeads: '{count} ungelesen',
      searchByNameOrEmailPlaceholder: 'Nach Name oder E-Mail suchen...'
    }
  },
  leadRightPanel: {
    tabActivity: 'Aktivität',
    tabOrientations: 'Orientierungen'
  },
  commercial: {
    title: 'Kommerzielle Bereich',
    commercialManager: 'Kommerzielle Manager',
    dashboard: {
      title: 'Dashboard Kommerzielle',
      leadsToProcess: 'Leads zu verarbeiten (Neu)',
      totalLeads: 'Gesamte Leads',
      processedLeads: 'Verarbeitete Leads',
      actionsTitle: 'Anrufe & Aufgaben zu erledigen',
      overdue: 'Überfällig',
      today: 'Heute',
      future: 'Kommende (10 kommende)',
      noActions: 'Kein Anruf oder Aufgabe geplant.',
      taskLabel: 'Aufgabe',
      callLabel: 'Anruf'
    },
    leads: {
      title: 'Gestaltung der Leads',
      searchPlaceholder: 'Nach Name oder E-Mail suchen...',
      searchButton: 'OK',
      advancedFiltersButton: 'Erweiterte Filter',
      groupStatus: {
        toProcess: 'Zu verarbeiten',
        processed: 'Verarbeitet',
        closed: 'Geschlossen',
        all: 'Alle'
      },
      filters: {
        status: 'Status',
        commercial: 'Kommerzielle',
        source: 'Quelle',
        dateFrom: 'Von',
        dateTo: 'Bis',
        allStatuses: 'Alle Status',
        allCommercials: 'Alle Kommerzielle',
        allSources: 'Alle Quellen'
      },
      table: {
        noLeadsFoundFilters: 'Keine Leads gefunden. Überprüfen Sie Ihre Filter oder laden Sie die Seite neu.',
        noLeadsFoundSearch: 'Keine Leads gefunden, die den Suchkriterien entsprechen',
        headers: {
          name: 'Name',
          phone: 'Telefon',
          email: 'E-Mail',
          source: 'Quelle',
          status: 'Status',
          commercial: 'Kommerzielle',
          date: 'Datum',
          actions: 'Aktionen'
        }
      },
      actions: {
        viewDetailsTitle: 'Details ansehen',
        viewHistoryTitle: 'Historik ansehen',
        assignCommercial: 'Kommerzielle zuweisen'
      },
      pagination: {
          previous: 'Vorherige',
        next: 'Nächste',
        showingLeads: 'Anzeige von {from} bis {to} von {total} Leads',
        previousSr: 'Vorherige',
        nextSr: 'Nächste'
      },
      historyModal: {
        title: 'Historie',
        closeSr: 'Schließen',
        noHistory: 'Keine Historie verfügbar',
        systemUser: 'System',
        typeCommercial: 'Kommerzielle',
        typeStatus: 'Status'
      },
      errors: {
        loadFailed: 'Fehler beim Laden der Leads: {message}',
        loadGeneric: 'Ein Fehler ist beim Laden der Leads aufgetreten',
        statusUpdateFailed: 'Ein Fehler ist beim Aktualisieren des Status aufgetreten',
        assignFailed: 'Ein Fehler ist beim Zuweisen der Kommerzielle aufgetreten'
      },
      history: {
        commercialPrefix: 'Kommerzielle: ',
        noCommercial: 'Keine Kommerzielle'
      }
    },
    map: {
      title: 'Karte der Einrichtungen',
      backToDashboard: 'Zurück zum Dashboard',
      searchFacilityPlaceholder: 'Einrichtung suchen...',
      searchCityPlaceholder: 'Stadt suchen...',
      drawRadiusLabel: 'Zeichne einen Radius von',
      kmUnit: 'km',
      applyFilterButton: 'Anwenden',
      resetFilterButton: 'Zurücksetzen',
      filterByTypeTitle: 'Nach Typ filtern:',
      noTypesToFilter: 'Kein Typ zum Filtern.',
      popup: {
        unknownName: 'Unbekannter Name',
        groupLabel: 'Gruppe: ',
        typesLabel: 'Typ(e): '
      },
      errors: {
        selectCityFirst: 'Bitte wählen Sie eine Stadt aus der Liste aus, bevor Sie den Filter anwenden.',
        mapInstanceUnavailable: 'Fehler: Karteninstanz nicht verfügbar.',
        cannotDetermineCountry: 'Es ist nicht möglich, das Land des Benutzers zu bestimmen.',
        errorLoadingLeadData: 'Fehler beim Laden der Lead-Daten.',
        validationError: 'Fehler bei der Validierung der Orientierungen:',
        realtimeError: 'Fehler bei der Verbindung mit der Echtzeit-Datenquelle'
      },
      leadInfoTitle: 'Lead-Informationen',
      leadNameLabel: 'Name:',
      leadEmailLabel: 'E-Mail:',
      leadPhoneLabel: 'Telefon:',
      leadDesiredTypeLabel: 'Gewünschter Typ:',
      leadWishesLabel: 'Wünsche:',
      leadRadiusLabel: 'Mögliche Entfernung:',
      orientationForLead: 'Orientierung für den Lead',
      orientButton: 'Orientieren',
      alreadyInBasket: 'Bereits in den Orientierungen',
      basketTitle: 'Orientierungen',
      basketEmpty: 'Keine Orientierung verfügbar',
      validateButton: 'Orientierungen validieren',
      loadingComplete: 'Laden abgeschlossen',
      facilityTypesCount: 'Einrichtungstypen',
      facilitiesCount: 'Einrichtungen',
      countryId: 'Land-ID',
      retryButton: 'Erneut versuchen'
    },
    facilities: {
      title: 'Einrichtungen',
      searchPlaceholder: 'Einrichtung suchen...',
      filterPaying: 'Nur bezahlte Einrichtungen',
      filterGroup: 'Nach Gruppe filtern',
        filterType: 'Nach Typ filtern',
      allGroups: 'Alle Gruppen',
      allTypes: 'Alle Typen',
      payingStatus: {
        all: 'Alle',
        yes: 'Bezahlt',
        no: 'Nicht bezahlt'
      },
      listTitle: 'Einrichtungsübersicht',
      name: 'Name',
      location: 'Standort',
      group: 'Gruppe',
      types: 'Typen',
      paying: 'Bezahlt',
      actions: 'Aktionen',
      view: 'Ansehen',
      noFacilities: 'Keine Einrichtungen gefunden für die ausgewählten Kriterien.',
      pagination: {
        show: 'Anzeigen',
        showing: 'Anzeige von {from} bis {to} von {total} Einrichtungen',
        previous: 'Vorherige',
        next: 'Nächste',
        previousSr: 'Vorherige',
        nextSr: 'Nächste'
      }
    },
    actions: {
      noActions: 'Noch keine Aktion durchgeführt',
      note: 'Notiz',
      appel: 'Anruf',
      email: 'E-Mail',
      task: 'Aufgabe',
      statuses: {
        programmed: 'Programmiert',
        contacted: 'Kontaktiert',
        notContacted: 'Nicht kontaktiert',
        todo: 'Zu tun',
        done: 'Erledigt',
        undefined: 'Nicht definiert'
      },
      form: {
        addNote: 'Notiz hinzufügen',
        addCall: 'Anruf hinzufügen',
        addEmail: 'E-Mail senden',
        addTask: 'Aufgabe hinzufügen',
        editNote: 'Notiz bearbeiten',
        editCall: 'Anruf bearbeiten',
        editEmail: 'E-Mail bearbeiten',
        editTask: 'Aufgabe bearbeiten',
        sending: 'Senden...',
        save: 'Speichern',
        saveChanges: 'Änderungen speichern',
        add: 'Hinzufügen'
      },
      labels: {
        date: 'Datum',
        status: 'Status',
        by: 'Von',
        to: 'An',
        cc: 'CC',
        bcc: 'BCC',
        subject: 'Betreff',
        from: 'Von',
          user: 'Benutzer',
        loading: 'Laden...',
        markAsDone: 'Als erledigt markieren',
        contactedCall: 'Kontaktiert',
        notContactedCall: 'Nicht kontaktiert',
        noModels: 'Kein Modell verfügbar',
        sharedModels: 'Geteilte Modelle',
        myModels: 'Meine Modelle',
        loadingModels: 'Laden der Modelle...',
        noSubject: 'Kein Betreff',
        noRecipient: 'N/A',
        all: 'Alle',
        email: 'E-Mail',
        call: 'Anruf',
        note: 'Notiz',
        task: 'Aufgabe',
        addCall: 'Anruf hinzufügen',
        addNote: 'Notiz hinzufügen',
        sendEmail: 'E-Mail senden',
        addTask: 'Aufgabe hinzufügen'
      },
      confirmDelete: {
        title: 'Sind Sie sicher, dass Sie dieses Element löschen möchten?',
        text: 'Sind Sie sicher, dass Sie diese {type} löschen möchten?',
        cancel: 'Abbrechen',
        confirm: 'Löschen'
      },
      history: {
        modified: 'Status des Anrufs geändert',
        new: 'Neuer Status des Anrufs',
        actionModified: 'Aktion geändert',
        actionAdded: 'Aktion hinzugefügt',
        taskAdded: 'Aufgabe hinzugefügt',
        emailSent: 'E-Mail gesendet',
        actionDeleted: 'Aktion gelöscht',
        oldDate: 'Alte Datum',
        newDate: 'Neues Datum',
        state: 'Status',
        oldNote: 'Alte Notiz',
        newNote: 'Neue Notiz',
        note: 'Notiz',
        description: 'Beschreibung',
        deadline: 'Fälligkeit',
        content: 'Inhalt',
        noContent: 'Kein Inhalt'
      },
      delete: {
        confirmTitle: 'Aktion löschen',
          confirmMessage: 'Sind Sie sicher, dass Sie diese Aktion löschen möchten? Diese Aktion ist endgültig.',
        cancel: 'Abbrechen',
        confirm: 'Löschen'
      },
      emailAction: {
        newMessage: 'Neue Nachricht',
        saveAsModel: 'Als Modell speichern',
        modelName: 'Modellname',
        modelNamePlaceholder: 'Beispiel: Bestätigung der Buchung',
        columns: 'Spalten',
        models: 'Modelle',
        insertColumn: 'Spalte einfügen',
        newModel: 'Neu',
        sent: 'E-Mail gesendet',
        noSubject: 'Kein Betreff',
        send: 'Senden',
        requiredFields: 'Die Felder Empfänger und Betreff sind erforderlich',
        template: {
          nameRequired: 'Bitte geben Sie einen Namen für das Modell ein',
          missingUserInfo: 'Benutzerinformationen fehlen',
          saveError: 'Fehler beim Speichern'
        }
      },
      lead: {
        facilityNoteTitle: "Notiz für das Etablissement",
        saveNote: "Notiz speichern",
        savingNote: "Speichern...",
        notFound: "Lead nicht gefunden",
        errors: {
          statusUpdateFailed: "Fehler beim Aktualisieren des Status",
          saveFailed: "Fehler beim Speichern des Namens"
        },
        parentOptionsLabels: {
          friend: 'Freund(e)',
          greatGrandchild: 'Groß-Enkel',
          other: 'Andere',
          daughterInLaw: 'Schwiegertochter',
          sisterInLaw: 'Schwiegertochter',
          partner: 'Lebenspartner(in)',
          spouse: 'Ehepartner(in)',
          cousin: 'Cousin(in)',
          curator: 'Vormund',
          daughter: 'Tochter',
          son: 'Sohn',
          brother: 'Bruder',
          sonInLaw: 'Schwiegersohn',
          agent: 'Vertreter',
          doctorOrganizations: 'Arzt - Organisationen',
          generalPractitioner: 'Allgemeinmediziner',
          mother: 'Mutter',
          nephew: 'Neffe',
          niece: 'Nichte',
          notary: 'Notar',
          uncle: 'Onkel',
          father: 'Vater',
          personItself: 'Selbst',
          myself: 'Myself',
          grandchild: 'Enkel',
          legalRepresentative: 'Rechtsvertreter',
          sister: 'Schwester',
          aunt: 'Tante',
          guardian: 'Betreuer'
        },
        admissionOptionsLabels: {
          immediate: 'Sofort',
          oneToThreeMonths: '1-3 Monate',
          threeToSixMonths: '3-6 Monate',
          moreThanSixMonths: '+ 6 Monate'
        }
      },
      leadElderly: {
        sectionTitle: 'Ältere Personen',
        addPersonButton: 'Person hinzufügen',
        editPersonTitle: 'Informationen bearbeiten',
        ageLabel: 'Alter',
        currentStayLabel: 'Aktueller Aufenthaltsort',
        currentStayOptions: {
          home: 'Zuhause',
          healthFacility: 'Krankenhaus',
          family: 'Bei der Familie',
          careHome: 'In einem Pflegeheim / einem Altenheim',
          other: 'Autre'
        },
          postalCodeLabel: 'Postleitzahl des Wohnsitzes',
        postalCodePlaceholder: 'Geben Sie eine Postleitzahl oder einen Ort ein',
        postalCodeSearching: 'Suche läuft...',
        autonomyLabel: 'Selbstständigkeit',
        autonomyOptions: {
          valid: 'Gut',
          semiValid: 'Halb gut',
          dependent: 'Abhängig',
          veryDependent: 'Sehr abhängig'
        },
        cognitiveStateLabel: 'Cognitive State',
        cognitiveStateOptions: {
          none: 'Kein',
          little: 'Wenig',
          advanced: 'Fortgeschritten',
          veryAdvanced: 'Sehr fortgeschritten'
        },
        stayTypeLabel: 'Aufenthaltsart',
        stayTypeOptions: {
          permanent: 'Dauerhaft',
          temporary: 'Temporär',
          shortStay: 'Kurzaufenthalt'
        },
        editButtonTitle: 'Bearbeiten',
        deleteButtonTitle: 'Löschen',
        yearsSuffix: 'Jahre',
        displayLabels: {
          postalCode: 'Code postal:',
          currentLocation: 'Aktueller Standort:',
          autonomy: 'Selbstständigkeit:',
          cognitiveState: 'Cognitive State:',
          stayType: 'Aufenthaltsart:'
        },
        alerts: {
            missingCountryIdError: 'country_id fehlt für den Lead.',
          postalCodeSearchError: 'Fehler beim Suchen der Postleitzahl.',
          postalCodeLoadError: 'Fehler beim Laden der Postleitzahlinformationen.',
          saveError: 'Fehler beim Speichern',
          deleteConfirm: 'Sind Sie sicher, dass Sie diese Person löschen möchten?',
          deleteError: 'Fehler beim Löschen'
        },
        noElderlyMessage: 'Keine ältere Personen eingetragen',
        history: {
          addition: 'Hinzufügen',
          modification: 'Änderung',
          noPerson: 'Keine Person',
          elderlyPerson: 'Ältere Person {index}',
          addedPerson: 'Ältere Person hinzugefügt: {personName}',
          modifiedPerson: 'Ältere Person geändert: {personName}',
          deletedPerson: 'Ältere Person gelöscht {index}'
        }
      },
      leadLocalisation: {
        sectionTitle: 'Gewünschte Standorte',
        deleteButtonTitle: 'Standort löschen',
        addLocationButton: 'Standort hinzufügen',
        searchInputPlaceholder: 'Suchen Sie nach einer Stadt, einem Departement oder einer Postleitzahl',
        suggestionGroupLabels: {
          departments: 'Departements',
          cities: 'Städte'
        },
        addingInProgress: 'Hinzufügen läuft...',
        radiusLabel: 'Mögliche Entfernung',
        desiredResidenceLabel: 'Gewünschte Wohnung',
        radiusOptions: {
          km0: '0 km',
          km10: '10 km',
          km20: '20 km',
          km30: '30 km',
          km40: '40 km',
          km50: '50 km',
          km80: '80 km',
          km100: '100 km',
          km150: '150 km'
        },
        alerts: {
          searchError: 'Fehler beim Suchen.',
          noSlotError: 'Kein Standort verfügbar für den Hinzufügen.',
          addErrorConsole: 'Fehler beim Hinzufügen des Standorts.',
          addErrorAlert: 'Fehler beim Hinzufügen des Standorts.',
          notFoundInLeadError: 'Standort nicht gefunden im Lead.',
          deleteErrorConsole: 'Fehler beim Löschen des Standorts.',
          deleteErrorAlert: 'Fehler beim Löschen des Standorts.',
          updateFieldErrorConsole: 'Fehler beim Aktualisieren des Felds.',
          updateFieldErrorAlert: 'Fehler beim Aktualisieren des Felds.'
        }
      },
      loading: 'Laden der Aktivitäten...',
      noActivity: 'Keine Aktivitäten für den Moment.',
      editEmailNotImplemented: "Die Bearbeitung von bestehenden E-Mails ist noch nicht mit dem neuen Composer implementiert.",
      deleteActionConfirm: 'Sind Sie sicher, dass Sie diese Aktion löschen möchten?',
      taskForm: {
        statusOptions: {
          todo: 'Zu tun',
          done: 'Erledigt'
        },
        errors: {
          loadUsersError: 'Fehler beim Laden der Benutzerliste',
          contentRequired: 'Der Inhalt der Aufgabe ist erforderlich',
          saveError: 'Fehler beim Speichern. Bitte versuchen Sie es erneut.'
        },
        loadingUsers: 'Laden der Benutzer...',
        titleEdit: 'Aufgabe bearbeiten',
        titleNew: 'Neue Aufgabe',
        statusLabel: 'Status *',
        assignedToLabelTodo: 'Zu tun von *',
        assignedToLabelDone: 'Erledigt von *',
        unassigned: 'Nicht zugewiesen',
        optgroupYou: 'Sie',
        optgroupUsers: 'Benutzer',
        userSuffixYou: '(Sie)',
        dateTimeLabel: 'Datum und Uhrzeit *',
        descriptionLabel: 'Beschreibung der Aufgabe *',
        descriptionPlaceholder: 'Beschreiben Sie die Aufgabe...',
        buttons: {
          cancel: 'Abbrechen',
          edit: 'Bearbeiten',
          create: 'Erstellen'
        }
      }
    },
    leadHeader: {
      civilityLabel: 'Anrede',
      civilityPlaceholder: '--',
      civilityOptions: {
        mr: 'Herr',
        mrs: 'Frau',
        ms: 'Frau'
      },
      firstNameLabel: 'Vorname',
      lastNameLabel: 'Nachname',
      dossierNumber: 'Akte Nr.'
    },
    contactInfoTitle: 'Kontaktinformationen',
    fieldLabelPhone: 'Telefon',
    fieldLabelEmail: 'E-Mail',
    fieldLabelDesiredFacilityType: "Gewünschter Einrichtungstyp",
    fieldLabelUnspecified: 'Nicht spezifiziert',
    fieldLabelParentLink: 'Verwandtschaftsverhältnis',
    fieldLabelAdmissionDelay: "Einlassverzögerung",
    selectPlaceholder: 'Wählen Sie...',
    filterPlaceholder: 'Filtern...',
    noResultsMessage: 'Keine Ergebnisse',
    notCommunicatedShort: 'N.C.',
    creationDateLabel: 'Erstellungsdatum',
    sourceLabel: 'Quelle',
    assignCommercialButtonLabel: 'Zuweisen'
  },
  // Traductions pour le composant MinimizedEmailComposer
  emailComposer: {
    newMessage: 'Neue Nachricht',
    noRecipient: 'Kein Empfänger',
    maximizeButtonTitle: 'Vergrößern',
    closeButtonTitle: 'Schließen',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefonnummer',
    creationDate: 'Erstellungsdatum',
    myTemplates: 'Meine Vorlagen',
    sharedTemplates: 'Geteilte Vorlagen',
    personalTemplates: 'Persönliche Vorlagen',
    saveAsTemplate: 'Als Vorlage speichern',
    templateName: 'Vorlagenname',
    templateNamePlaceholder: 'Beispiel: Bestätigung der Buchung',
    cancel: 'Abbrechen',
    save: 'Speichern',
    selectTemplate: 'Vorlage auswählen',
    new: 'Neu',
    loadingTemplates: 'Laden der Vorlagen...',
    noTemplatesAvailable: 'Keine Vorlagen verfügbar',
    templates: 'Vorlagen',
    columns: 'Spalten',
    insertColumn: 'Spalte einfügen'
  },
  activityTask: {
    markAsDone: 'Als erledigt markieren',
    deleteConfirm: 'Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?',
    editTitle: 'Aufgabe bearbeiten',
    deleteTitle: 'Aufgabe löschen',
    date: 'Datum',
    status: 'Status',
    by: 'Von'
  },
  activityNote: {
    deleteConfirm: 'Sind Sie sicher, dass Sie diese Notiz löschen möchten?',
    editTitle: 'Notiz bearbeiten',
    deleteTitle: 'Notiz löschen'
  },
  commercialTask: {
    taskForm: {
      unassigned: 'Nicht zugewiesen'
    }
  },
  orientations: {
    missingOrientationAlert: "Der Benutzer hat diesen Lead für die Wohnung {facilityName} in {geoEntityName} ({geoEntityCode}) gesendet, aber es gibt keine Orientierung.",
    createOrientation: "Orientierung erstellen",
    orientLead: "Lead orientieren",
    searchFacility: "Einrichtung suchen",
    facilityNamePlaceholder: "Name der Einrichtung...",
    group: "Gruppe",
    type: "Typ",
    orient: "Orientieren",
    orientFromMap: "Orientieren von der Karte",
    addingOrientation: "Orientierung hinzufügen...",
    orientationsToValidate: "Orientierungen zu validieren",
    checkAll: "Alles auswählen",
    validate: "Validieren {count} Orientierung{count > 1 ? 'en' : ''}",
    addedOn: "Hinzugefügt am",
    deleteOrientation: "Orientierung löschen",
    sentOrientations: "Orientierungen gesendet",
    noSentOrientations: "Keine Orientierungen gesendet.",
    sentOn: "Gesendet am",
    leadId: "Lead-ID",
    deleteOrientationAndLead: "Orientierung und zugehöriges Lead löschen (falls nicht bearbeitet)",
    confirmationRequired: "Bestätigung erforderlich",
    emptyNoteWarning: "Die Notiz für die Einrichtung ist leer. Bitte füllen Sie sie vor der Validierung der Orientierungen aus."
  },
  taskForm: {
    new: 'Neue Aufgabe',
    edit: 'Aufgabe bearbeiten',
    status: {
      todo: 'Zu tun',
      done: 'Erledigt',
      undefined: 'Nicht definiert'
    },
    statusLabel: 'Status',
    assignedTodo: 'Zu tun von',
    assignedDone: 'Erledigt von',
    loadingUsers: 'Laden der Benutzer...',
    you: 'Sie',
    users: 'Benutzer',
    dateTime: 'Datum und Uhrzeit',
    description: 'Beschreibung der Aufgabe',
    descriptionPlaceholder: 'Beschreiben Sie die Aufgabe...',
    saveError: 'Fehler beim Speichern. Bitte versuchen Sie es erneut.'
  },
  activityForm: {
    modify: 'Bearbeiten',
    add: 'Hinzufügen',
    note: 'eine Notiz',
    email: 'eine E-Mail',
    call: 'ein Anruf',
    task: 'eine Aufgabe',
    sending: 'Senden...',
    saveChanges: 'Änderungen speichern',
    requiredFields: 'Bitte füllen Sie alle Pflichtfelder aus',
    emptyContent: 'Der Inhalt kann nicht leer sein.',
    date: 'Datum',
    time: 'Uhrzeit',
    status: 'Status',
    content: 'Inhalt',
    noteT: 'Notiz',
    taskN: 'Aufgabe',
    selectCommercial: 'Wählen Sie einen Vertreter',
    you: '(Sie)',
    callStatus: {
      scheduled: 'Geplant',
      contacted: 'Kontaktiert',
      notContacted: 'Nicht kontaktiert'
    },
    callState: 'Status des Anrufs',
    assignedTo: 'Zugewiesen an',
    callNotePlaceholder: 'Schreiben Sie Ihre Anrufnotiz hier (optional)...',
    contentPlaceholder: 'Schreiben Sie Ihren Inhalt hier...',
    loadingCommercials: 'Laden der Vertreter...'
  },
  emailComposerForm: {
    sharedTemplates: 'Geteilte Vorlagen',
    templates: 'Vorlagen',
    columns: 'Spalten',
    insertColumn: 'Spalte einfügen'
  }
}